<template>
    <div class="fdca-header" id="fdca-header" data-app>
        <div class="v-overlay" id="modify_overlay"></div>
        <v-container grid-list-md v-if="this.showContinue === false" >
            <v-layout row wrap justify-center>
                <v-flex xs3 sm6 md6 lg4>
                    <img src="../assets/images/FDCA-Logo-horizontal.svg" class="img_big" id="img_big"/>
                    <img src="../assets/images/FDCA-Logo-Lockup.svg" class="img_small" id="img_small"/>
                </v-flex>
                <!-- click.stop="dialog = true" -->
                <v-flex xs5 offset-xs4 sm3 md2 lg3 offset-sm3 offset-md4 align-self-center>
                    <div v-if="this.$store.state.sessionDetails !== null &&
                    this.$store.state.sessionDetails.properties.session_quote_reference_id !== null &&
                    this.$route.name === 'Renewals'"
                    @click="clickModal()">
                        Your quote ref: <strong>{{this.$store.state.sessionDetails.properties.session_quote_reference_id}}</strong> <IconBase style="cursor:pointer;"><IconCustomerSupport /></IconBase>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        <!-- <v-container grid-list-md v-if="this.showContinue === true">
            <v-layout row wrap>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    <div class="edit_your_information"><span class="icon-next" @click="back()"><IconBase><IconArrowBack /></IconBase></span> Edit your Information</div>
                    <img src="../assets/FDCA-Logo-horizontal.svg" class="display_none"/>
                </v-flex>
            </v-layout>            
        </v-container> -->
        
        <v-dialog
        v-model="dialog"
        max-width="370"
        class="modal_reference_quote"
        persistent
        :fullscreen="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
        >
        <v-card>
            <v-card-text>
                <div class="nav_close_container">
                    <v-btn icon @click="disableModal()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </div>
                <div class="quote_modal_container">
                    <div class="quote_modal_big_text modal_text_header" v-if="this.$store.state.sessionDetails">{{ this.$store.state.sessionDetails.properties.session_quote_reference_id }}</div>
                    <div class="quote_modal_text f18">Is your quote reference number</div>
                    <div class="quote_modal_text">You can retreive your insurance quote at any time for the next <span class="f600">30 days</span> by entering this code, plus your date of birth. </div>
                    <div class="quote_modal_text">If you need assistance from our Customer Services team, you can quote this reference number when you call us on:</div>
                    <div class="quote_modal_big_text modal_phone_number">1800 658 699</div>
                    <div>
                        <a href="tel:1800658698" class="remove_"><v-btn round flat  id="call-btn" class="call-btn">Call us now<span class="icon-call"><IconBase><IconCustomerSupport /></IconBase></span></v-btn></a>
                    </div>
                    <div class="modal_bottom_text">
                        Lines open Mon–Sat 9am–6pm AEST
                    </div>
                </div>
            </v-card-text>
        </v-card>
        </v-dialog>

    </div>
</template>

<script>
import IconBase from '@/components/IconBase.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconCustomerSupport from '@/components/icons/customerSupport.vue'


export default {
    name: "Header",
    props: ['EditStatus', 'ServiceCurrentStep', 'PathName','active_modal'],
    components: {
        IconBase,
        IconArrowBack,
        IconCustomerSupport
    },
    data() {
        return{
            showContinue: false,
            setQuoteRef: "",
            dialog: false,
            showButton: false,
        }  
    },
    watch: {
        //this.$parent.EducatorInsuranceProcess.quote_ref_num
        EditStatus: function(newVal, oldVal) {
            if(newVal == true){
                this.showContinue = true;
                var x = document.getElementById("fdca-header").classList.add("auto-height");
            }else{
                this.showContinue = false;
                var x = document.getElementById("fdca-header").classList.remove("auto-height");
            }
        },
        ServiceCurrentStep: function(newVal, oldVal) {
            if(parseInt(newVal) > 1){
                var x = document.getElementById("quote_container").classList.remove("qc_display_none");
            }else{
                var x = document.getElementById("quote_container").classList.add("qc_display_none");
            }

        },

        PathName : function (newVal, oldVal) {
            if(this.$parent.Role == 'service'){
                this.setQuoteRef = this.$parent.ServiceInsuranceProcess.quote_ref_num;
            }else{
                this.setQuoteRef = this.$parent.EducatorInsuranceProcess.quote_ref_num;
            }
            if(this.setQuoteRef != undefined){
                this.showButton = true;
            }else{
                this.showButton = false;
            }
        },
        dialog : function (newVal, oldVal) {
            if(newVal == true){
                let app =  document.getElementsByClassName("fdca-header")[0].createAttribute('data-app'); 
            }else{
                let app =  document.getElementsByClassName("fdca-header")[0].removeAttribute('data-app', false); 

            }
            
        }

    },
    methods: {
        back(){
            this.$parent.EditStatus = false;
            this.showContinue = false;
        },
        clickModal(){
            this.dialog = true;
        },
        disableModal(){
            this.dialog = false
            
        }
    },
    mounted () {
        document.getElementsByClassName("fdca-header")[0].setAttribute('data-app', false);
        if(this.$parent.CurrentStep <= 1){
            this.$parent.CurrentStep = 0;
        }
        this.$parent.CheckWindowPathName();

        if(this.$parent.Role == 'service' && this.$parent.ServiceInsuranceProcess.quote_ref_num != undefined){
            this.showButton = true;
            this.setQuoteRef = this.$parent.ServiceInsuranceProcess.quote_ref_num;
        }else if(this.$parent.EducatorInsuranceProcess.quote_ref_num && this.$parent.Role == 'educator'){
            this.showButton = true;
            this.setQuoteRef = this.$parent.EducatorInsuranceProcess.quote_ref_num;
        }else{
            this.showButton = false;
        }
        this.showDialog = true;
    }
}
</script>

<style lang="css" scoped>
    .auto-height{
        min-height: auto !important;
    }
    

    .display_none, .qc_display_none{
        display:none;
    }

    .fdca-header {
        min-height: 120px;
        border-bottom: 1px solid #DBDBDB;
        background-color: #FFFFFF;
    }
    
    .icon-next svg{
        width: 45px;
        height: 28px;
        vertical-align: middle
    }
    .icon-call svg{
        width: 20px;
        height: auto;
        vertical-align: middle;
    }
    .icon-call{
        margin-left: 10px;
    }
    .icon-next{
        margin-right: 20px;
        cursor:pointer
    }
    .quote_text{
        font-weight: 501;
        font-size:1.3rem;
    }
    .quote_container{
        text-align: right;
        margin-top: 20px;
        cursor: pointer;
    }
    .img_small{
        display:none;
    }
    


    @media screen and (min-width: 1099px) {
        .auto-height{
            min-height: 120px;
        }
        .edit_your_information{
            display:none;
        }
        .display_none{
            display:block;
        }

    }

    @media screen and (max-width: 600px) {
        .img_small{
            display:block;
            margin-top:15px;
        }
        .img_big{
            display: none;
        }

        .fdca-header{
            min-height: 100px;
        }


       
    }

    #modify_overlay{
        z-index: 201;
    }

    a.remove_{text-decoration: none;}
    
    
</style>

